<template lang="pug">
.headline.mb-3.mt-2
  | {{ $t(title) }}
  slot
</template>

<script>
export default {
  name: 'PageTitle',
  metaInfo () {
    return {
      changed: _ => { this.title = _.titleChunk },
    }
  },
  data () {
    return {
      title: null,
    }
  },
}
</script>

<style scoped lang="sass">
.headline
  display: flex
  align-items: center
</style>
